/**
 * Conversions entre l'ISO de l'API et le format qu'attend `<input type="datetime-local">`.
 *
 * `datetime-local` ne connaît pas les fuseaux : il lit et rend une heure locale nue. La régie
 * saisit donc en heure locale, et le formulaire repart en ISO — c'est le seul endroit du front
 * où la bascule a lieu. Le module reste séparé de `features/session/format.ts`, réservé à
 * l'affichage.
 */

/** ISO → « 2026-09-01T18:00 », en heure locale du navigateur. */
export function toLocalInput(iso: string): string {
  return formatLocalInput(new Date(iso));
}

/** « 2026-09-01T18:00 » (heure locale) → ISO UTC, tel que l'API l'attend. */
export function toIsoFromLocalInput(local: string): string {
  return new Date(local).toISOString();
}

/**
 * Début local + durée par défaut du cercle, au format `datetime-local`.
 *
 * Rend une chaîne vide si le début n'est pas encore saisi : le champ de fin reste alors vide
 * plutôt que d'afficher une date née d'un `NaN`.
 */
export function endFromStart(localStart: string, durationMinutes: number): string {
  if (!localStart) return '';
  const start = new Date(localStart);
  if (Number.isNaN(start.getTime())) return '';
  return formatLocalInput(new Date(start.getTime() + durationMinutes * 60_000));
}

function formatLocalInput(date: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
